/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Noachievements2Inputs */

const id_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pencapaian ditemukan`)
};

const ms_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada pencapaian ditemui`)
};

const da_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen achievements fundet`)
};

const de_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Errungenschaften gefunden`)
};

const en_us2_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No achievements found`)
};

const es_es2_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron logros`)
};

const es_mx2_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron logros`)
};

const fil_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang achievement`)
};

const fr_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun succès trouvé`)
};

const it_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato trovato`)
};

const hu_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található teljesítmény`)
};

const nl_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen prestaties gevonden`)
};

const no_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen prestasjoner funnet`)
};

const pl_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono osiągnięć`)
};

const pt_br2_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conquista encontrada`)
};

const pt_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conquista encontrada`)
};

const ro_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit realizări`)
};

const fi_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutuksia ei löytynyt`)
};

const sv_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga prestationer hittades`)
};

const vi_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy thành tích`)
};

const tr_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarım bulunamadı`)
};

const cs_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné úspěchy`)
};

const bg_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени постижения`)
};

const ru_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достижения не найдены`)
};

const uk_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнень не знайдено`)
};

const ar_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على إنجازات`)
};

const hi_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई उपलब्धियाँ नहीं मिलीं`)
};

const th_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบความสำเร็จ`)
};

const ja_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績が見つかりません`)
};

const zh_cn2_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到成就`)
};

const zh_hant1_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到成就`)
};

const ko_offerdetail_achievements_noachievements2 = /** @type {(inputs: Offerdetail_Achievements_Noachievements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제 없음`)
};

/**
* | output |
* | --- |
* | "No achievements found" |
*
* @param {Offerdetail_Achievements_Noachievements2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_noachievements2 = /** @type {((inputs?: Offerdetail_Achievements_Noachievements2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Noachievements2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_noachievements2(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_noachievements2(inputs)
	if (locale === "da") return da_offerdetail_achievements_noachievements2(inputs)
	if (locale === "de") return de_offerdetail_achievements_noachievements2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_noachievements2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_noachievements2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_noachievements2(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_noachievements2(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_noachievements2(inputs)
	if (locale === "it") return it_offerdetail_achievements_noachievements2(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_noachievements2(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_noachievements2(inputs)
	if (locale === "no") return no_offerdetail_achievements_noachievements2(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_noachievements2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_noachievements2(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_noachievements2(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_noachievements2(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_noachievements2(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_noachievements2(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_noachievements2(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_noachievements2(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_noachievements2(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_noachievements2(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_noachievements2(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_noachievements2(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_noachievements2(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_noachievements2(inputs)
	if (locale === "th") return th_offerdetail_achievements_noachievements2(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_noachievements2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_noachievements2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_noachievements2(inputs)
	return ko_offerdetail_achievements_noachievements2(inputs)
});
export { offerdetail_achievements_noachievements2 as "offerDetail.achievements.noAchievements" }